import axios from 'axios'
import { apiConfigAuthenticated } from '@/api/config'

/**
 * Получить список пользователей с выданными ваучерами через ЛК
 * GET /api/v0/voucher/userswithvoucher/
 */
export const apiGetVouchers = function (token) {
  return axios.get(
    `/api/v0/voucher/userswithvoucher/`,
    apiConfigAuthenticated(token)
  )
}

/**
 * Удалить ваучер
 * PATCH /api/v0/voucher/userswithvoucher/<id>/
 * payload: { deleted_in_lk: true }
 */
export const apiDeleteVoucher = function (id, token) {
  return axios.patch(
    `/api/v0/voucher/userswithvoucher/${id}/`,
    {
      deleted_in_lk: true,
    },
    apiConfigAuthenticated(token)
  )
}

/**
 * Создать новый ваучер
 * POST /authorize/voucher_request/
 * payload: { fio: string, phone: string }
 */
export const apiCreateVoucher = function (data, token) {
  return axios.post(
    `/authorize/voucher_request/`,
    data,
    apiConfigAuthenticated(token)
  )
}



// WEBPACK FOOTER //
// ./src/api/voucher.js